import { InputType, Locale } from 'src/types'

import { ServiceType } from './enums'

export const getForm = (locale: Locale['maintenance']) => {
  const { addMaintenance: fieldsLocale } = locale

  return [
    {
      label: fieldsLocale.serviceType,
      placeholder: fieldsLocale.serviceTypePlaceholder,
      inputType: InputType.SELECT,
      name: 'serviceType',
    },
    {
      label: fieldsLocale.address,
      placeholder: fieldsLocale.addressPlaceholder,
      inputType: InputType.TEXT,
      name: 'address',
    },
    {
      label: fieldsLocale.odometer,
      placeholder: fieldsLocale.odometerPlaceholder,
      inputType: InputType.NUMBER,
      name: 'odometer',
    },
    {
      label: fieldsLocale.details,
      placeholder: fieldsLocale.detailsPlaceholder,
      inputType: InputType.TEXTAREA,
      name: 'details',
    },
    {
      label: fieldsLocale.cost,
      placeholder: fieldsLocale.costPlaceholder,
      inputType: InputType.NUMBER,
      name: 'serviceCost',
    },
  ] as const
}

export const getFieldValidationRules = (
  name: string,
  fieldsLocale: Locale['maintenance']['addMaintenance'],
) => {
  return name === 'details' ? {} : { required: fieldsLocale.requiredField }
}

export const getSelectFields = (locale: Locale['maintenance']) => {
  const { addMaintenance: fieldsLocale } = locale

  return [
    {
      value: ServiceType.OIL_CHANGE,
      placeholder: fieldsLocale.oilItem,
    },
    {
      value: ServiceType.FILTER_CHANGE,
      placeholder: fieldsLocale.filterItem,
    },
    {
      value: ServiceType.TIRE_CHANGE,
      placeholder: fieldsLocale.tireItem,
    },
    {
      value: ServiceType.REPAIR,
      placeholder: fieldsLocale.repair,
    },
  ] as const
}
